import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3b2b7f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "content-wrap" }
const _hoisted_4 = { class: "header-pfnr" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Proforma Number", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " : ", -1))
const _hoisted_7 = { else: "" }
const _hoisted_8 = { class: "pdf-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_PdfApp = _resolveComponent("PdfApp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (
                            _ctx.order.backoffice_reference == undefined ||
                            _ctx.order.backoffice_reference == null
                        )
            ? (_openBlock(), _createBlock(_component_i18n_t, {
                key: 0,
                keypath: "myOrders.notYetAvailable"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.order.backoffice_reference), 1),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: "/img/close-btn.svg",
              class: "close-popup-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createVNode(_component_PdfApp, {
            onPagesRendered: _ctx.pagesRendered,
            pdf: _ctx.pdf,
            pageScale: "page-height",
            style: {"height":"100vh","width":"83vh"},
            config: _ctx.pdfConfig
          }, null, 8, ["onPagesRendered", "pdf", "config"]), [
            [_vShow, _ctx.pdf !== '']
          ])
        ])
      ])
    ])
  ]))
}